import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { LanguageProvider } from './helpers/language-context';
import Layout from './components/layout';
import Home from './pages/home/index';
import Services from './pages/services/our-service/index';
import ServiceDetail from './pages/services/service-details/index';
import OurTeam from './pages/about/our-team/index';
import OurBrand from './pages/about/our-brand/index';
import OurHistory from './pages/about/our-history/index';
import WhoWeAre from './pages/about/who-we-are/index';
import Membership from './pages/about/membership/index';
import Subsidiary from './pages/services/subsidiary/index';
import Governance from './pages/governance/index';
import Career from './pages/career/index';
import OurStories from './pages/media/our-stories/index';
import OurStoriesDetail from './pages/media/our-stories/detail';
import NewsRelease from './pages/media/news-release/index';
import NewsReleaseDetail from './pages/media/news-release/detail';
import Awards from './pages/about/awards/index';
import Contact from './pages/contacts/index';
import Tender from './pages/contacts/tender';

// admin page
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import TendersEditor from './pages/admin/TendersEditor';
import NewsfeedEditor from './pages/admin/NewsfeedEditor';
import BoardMembersEditor from './pages/admin/BoardMembersEditor';
import JobOpeningsEditor from './pages/admin/JobOpeningsEditor';
import ManagementTeamEditor from './pages/admin/ManagementTeamEditor';
import AwardsEditor from './pages/admin/AwardsEditor';
import MembershipsEditor from './pages/admin/MembershipsEditor';
import PoliciesEditor from './pages/admin/PoliciesEditor';
import ServicesEditor from './pages/admin/ServicesEditor';
import SubsidiariesEditor from './pages/admin/SubsidiariesEditor';
import TimelineEditor from './pages/admin/TimelineEditor';
import WhistleblowerEditor from './pages/admin/WhistleblowerEditor';
import CorporateLiabilitiesEditor from './pages/admin/CorporateLiabilitiesEditor';
import WhistleblowerReports from './pages/admin/WhistleblowerReports';
import OurStoriesEditor from './pages/admin/OurStoriesEditor';
import CareerApplications from './pages/admin/CareerApplications';
import ContactMessages from './pages/admin/ContactMessages';
import ProtectedRoute from './components/admin/ProtectedRoute';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          {/* Admin Routes */}
          <Route path="/admin/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/admin/tenders" element={<TendersEditor />} />
            <Route path="/admin/newsfeed" element={<NewsfeedEditor />} />
            <Route path="/admin/board-members" element={<BoardMembersEditor />} />
            <Route path="/admin/job-openings" element={<JobOpeningsEditor />} />
            <Route path="/admin/management-team" element={<ManagementTeamEditor />} />
            <Route path="/admin/memberships" element={<MembershipsEditor />} />
            <Route path="/admin/policies" element={<PoliciesEditor />} />
            <Route path="/admin/services" element={<ServicesEditor />} />
            <Route path="/admin/subsidiaries" element={<SubsidiariesEditor />} />
            <Route path="/admin/timeline" element={<TimelineEditor />} />
            <Route path="/admin/awards" element={<AwardsEditor />} />
            <Route path="/admin/whistleblower" element={<WhistleblowerEditor />} />
            <Route path="/admin/corporate-liabilities" element={<CorporateLiabilitiesEditor />} />
            <Route path="/admin/our-stories" element={<OurStoriesEditor />} />
            
            {/* New Submission Pages */}
            <Route path="/admin/reports/whistleblower" element={<WhistleblowerReports />} />
            <Route path="/admin/reports/career" element={<CareerApplications />} />
            <Route path="/admin/reports/contact" element={<ContactMessages />} />
          </Route>

          {/* Public Routes */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/services/details/:serviceId" element={<ServiceDetail />} />
                <Route path="/services/subsidiary" element={<Subsidiary />} />
                <Route path="/about/our-team" element={<OurTeam />} />
                <Route path="/about/our-brand" element={<OurBrand />} />
                <Route path="/about/our-history" element={<OurHistory />} />
                <Route path="/governance" element={<Governance />} />
                <Route path="/about/who-we-are" element={<WhoWeAre />} />
                <Route path="/about/membership" element={<Membership />} />
                <Route path="/about/awards" element={<Awards />} />
                <Route path="/media/our-stories" element={<OurStories />} />
                <Route path="/media/our-stories/details/:storyId" element={<OurStoriesDetail />} />
                <Route path="/media/news-release" element={<NewsRelease />} />
                <Route path="/media/news-release/details/:newsId" element={<NewsReleaseDetail />} />
                <Route path="/career" element={<Career />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/contact/tender" element={<Tender />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
